(function () {
    "use strict";

    const POPUP_COMPONENT = "component-popup";
    const POPUP_CLOSE_SELECTOR = "[data-close-popup]";
    const NOTIFICATION_FORM_SELECTOR = "[data-notification-form]";
    const PRODUCT_NOTIFICATION_HEADING_SELECTOR = "[data-product-notification-heading]";
    const SUCCESS_CLASS = "has-success";
    const HIDDEN_CLASS = "hidden";

    if (!customElements.get("product-notification")) {
        class ProductNotification extends HTMLElement {

            constructor() {
                super();
                this.notificationForm = this.querySelector(NOTIFICATION_FORM_SELECTOR);
                this.preventSubmit = true;
                this.popupComponent = this.closest(POPUP_COMPONENT);
                this.popup = this.popupComponent?.querySelector("dialog") || this.closest("dialog");
                this.popupClose = this.popup?.querySelector(POPUP_CLOSE_SELECTOR);
            }

            connectedCallback() {
                if (!this.notificationForm || !this.popup) return;

                this.checkState();

                this.notificationForm.addEventListener("submit", (event) => {
                    this.notificationSubmitEvent(event);
                });

                if (this.popupClose) {
                    this.popupClose.addEventListener("click", () => {
                        this.removeStorage();
                    });
                }

                this.popup.addEventListener("close", () => {
                    this.removeStorage();
                });
            }

            checkState() {
                if (window.location.search.indexOf("?contact_posted=true") !== -1) {
                    // Hide the heading
                    this.querySelector(PRODUCT_NOTIFICATION_HEADING_SELECTOR)?.classList.add(HIDDEN_CLASS);
                    // Mark the popup component as having success
                    this.popupComponent?.classList.add(SUCCESS_CLASS);
                    // Open popup
                    if (typeof this.popupComponent?.open === "function") {
                        this.popupComponent.open();
                    } else if (typeof this.popup.showModal === "function") {
                        this.popup.showModal();
                    } else {
                        this.popup.setAttribute("open", "");
                    }
                }
            }

            notificationSubmitEvent(event) {
                if (this.preventSubmit) {
                    event.preventDefault();
                    this.removeStorage();
                    this.writeStorage();
                    this.preventSubmit = false;
                    this.notificationForm.submit();
                }
            }

            writeStorage() {
                if (typeof window.sessionStorage !== "undefined") {
                    window.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
                }
            }

            removeStorage() {
                window.sessionStorage.removeItem("notification_form_id");
            }
        }

        customElements.define("product-notification", ProductNotification);
    }
})();
